module.exports = __webpack_public_path__ + "Bliss2-Italic.e8bdd7336c19dd10bc20.woff";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2-Italic.woff
// module id = ../../../../../src/assets/layout/fonts/Bliss2-Italic.woff
// module chunks = styles